/* eslint-disable */
import React from "react";
import styles from "./Loader.scss";
import classnames from "classnames";
import { onlyUpdateForKeys } from "recompose";

function Loader(props) {
  return (
    <div className={classnames("wbkv9-Loader", styles.container + " " + props.className)}>
      <div className={classnames("wbkv9-Loader-loader", styles.loader)}>
        <svg className={styles.circular} viewBox="25 25 50 50">
          <circle
            className={styles.path}
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </div>
  );
}

export default onlyUpdateForKeys([])(Loader);
